<template>
    <div class="BaseNumber" :class="{'is-inline' : inline}">
        <label class="BaseNumber-label" v-if="label">{{ label }}:</label>
        <div class="BaseNumber-input">
            <input
                type="number"
                v-bind="$attrs"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                @blur="checkBoundaries($event.target.value)"
                ref="input"
            >
            <div class="BaseNumber-ranges">{{unit}} <template v-if="max">({{min}} - {{max}})</template></div>
        </div>
    </div>
</template>

<script>
    import {ref, onMounted} from 'vue';
    import {debounce} from "../../utils/utils";

	export default {
	    name: 'BaseInput',
		props: {
			label: String,
			modelValue: [String, Number],
            inline: Boolean,
            unit: String
		},
        setup(_,{emit}) {
	    	const input = ref(null);
	    	const min = ref(null);
	    	const max = ref(null);

			onMounted(() => {
				min.value = +input.value.getAttribute('min');
				max.value = +input.value.getAttribute('max');
			});
	    	
	    	const checkBoundaries = (value) => {
				if(min.value && min.value > +value) {
					emit('update:modelValue', min.value)
				}

				if(max.value && max.value < +value) {
					emit('update:modelValue', max.value)
				}
            }

            //const checkBoundariesDebounced = debounce((value) => checkBoundaries(value), 1100);

            return {
                min,
                max,
				input,
				checkBoundaries,
                //checkBoundariesDebounced
            }
        }
	}
</script>

<style lang="scss" scoped>
.BaseNumber {
    &.is-inline {
        label {
            display: inline-block;
            margin-right: .5em;
        }

        input {
            display: inline;
            width: 8em;
        }

        > div {
            display: flex;
            align-items: center;
            vertical-align: middle;
        }
    }

    &-ranges {
        text-align: right;
        margin-left: 1em;
    }

    label {
        display: block;
        font-weight: 700;
        margin-bottom: .5em;
    }

    input {
        padding: 1.3em;
        outline: 0;
        border: 2px solid var(--colorInputBorder);
        font-family: inherit;
        background: transparent;
        border-radius: 0;
        width: 100%;
        display: block;
    }
}
</style>
